/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  Vue,
  Component,
} from 'vue-property-decorator';

import {
  ProductVariant,
  ProductOption,
} from '@/models';

import { ProductFeatureContext } from './ProductFeatureContext';

const ProductFeatureProps = Vue.extend({
  props: {
    context: {
      type: Object as () => ProductFeatureContext,
      required: true,
    },
  },
});

@Component
export default class ProductFeature extends ProductFeatureProps {
  get isMobile() {
    return this.context.isMobile;
  }

  get variant() {
    return this.context.variant;
  }
  set variant(variant: ProductVariant) {
    this.$set(this.context, 'variant', variant);
  }

  get selectedValues() {
    return this.context.selectedValues;
  }

  get previewVariant() {
    return this.context.previewVariant;
  }
  set previewVariant(variant: ProductVariant | null) {
    this.$set(this.context, 'previewVariant', variant);
  }

  get hasUnselectedOptions() {
    return this.selectedValues.findIndex((option) => !option) >= 0;
  }

  get unselectedOptions() {
    return this.selectedValues.reduce<ProductOption[]>((prev, cur, idx) => {
      if (!cur) {
        prev.push(this.variant.options![idx].option);
      }
      return prev;
    }, []);
  }

  get unselectedOptionIndices() {
    return this.selectedValues.reduce<number[]>((prev, cur, idx) => {
      if (!cur) {
        prev.push(idx);
      }
      return prev;
    }, []);
  }
}
